<div [ngStyle]="styleObject">
  <div [ngStyle]="userPhotoCSS" class="picture"></div>
</div>

